const DATE_FORMAT = Symbol();

const LOCALE = Symbol();

const TIME_FORMAT = Symbol();

export { DATE_FORMAT as D, LOCALE as L, TIME_FORMAT as T };
